import { enableLoupe, Loupe } from './Loupe';

const magnification = 1
const style = {
	borderColor: "#4A4A4A",
	backgroundColor: "#F5F5F5",
	borderWidth: "1px",
	//boxShadow: "2px 3px 3px 2px rgba(0,0,0,0.5)",
	zIndex: "1",
}

const opt = {
	magnification,
	style,
}

const lp = new Loupe(opt);

(window as any).ApplyLoupe = function(selectedItem: JQuery<HTMLElement>) {
	if(selectedItem.hasClass("video")) //hide magnifier for video element
	{
		(window as any).isVideoSlide = true;
	}
	else {
		(window as any).isVideoSlide = false;
	}

	if(selectedItem.hasClass("model")) //hide magnifier for video element
	{
		(window as any).isModelSlide = true;
	}
	else {
		(window as any).isModelSlide = false;
	}

	if(selectedItem.hasClass("js-review-img"))
	{	
		return;
	}

	const domEle = $('#js-current-image')[0];
	const bigImgSrc = selectedItem.find('img').data('magsrc');

	//for large image, leave at least 100px from bottom
	const sectionHeight = $(".images-container .images-section").height();
	const imgHeight = $("#js-current-image img").height();
	let bottomMargin = (sectionHeight - imgHeight) > 155? 0 : (155 - (sectionHeight - imgHeight));

	if(selectedItem.hasClass("video")) //hide magnifier for video element
	{
		bottomMargin = sectionHeight;
	}

	(window as any).removeLoupe &&  (window as any).removeLoupe(); // before enableLoupe, please remove enabled Loupe
	(window as any).removeLoupe	= enableLoupe(domEle, bigImgSrc, lp, bottomMargin);
}; 

//enableLoupe;
document.addEventListener('DOMContentLoaded', function () {
	$($('.js-img-thumbs:not(.js-review-img) img')[0]).trigger('click', true)
}, false);
